var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative h-100" }, [
    _vm.showSingleLoginRegistration && !_vm.isLoggedIn
      ? _c("div", { staticClass: "h-100" }, [
          _c(
            "a",
            {
              staticClass: "nav-link",
              class: _vm.linkClass,
              attrs: {
                href: _vm.isLogin ? "javascript:void(0)" : "#login",
                "data-toggle": _vm.isLogin ? false : "modal",
                "aria-label": _vm.$translate("Ceres::Template.login"),
              },
              on: {
                click: function ($event) {
                  _vm.createRegisterLoginModal()
                  _vm.unmarkInputFields()
                },
              },
            },
            [
              _vm.loginLogo.length > 0
                ? _c("span", {
                    staticClass: "logo-navbar",
                    style: {
                      "background-image": "url('" + _vm.loginLogo + "')",
                    },
                  })
                : _c("i", {
                    staticClass: "fa fa-user mr-1",
                    class: _vm.logoClass,
                    attrs: { "aria-hidden": "true" },
                  }),
            ]
          ),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isLoggedIn
      ? _c("div", { staticClass: "dropdown d-flex align-items-center h-100" }, [
          _c(
            "a",
            {
              staticClass: "dropdown-toggle nav-link",
              class: _vm.linkClass,
              attrs: {
                href: "#",
                id: "accountMenuList",
                "data-toggle": "dropdown",
                "aria-haspopup": "true",
                "aria-expanded": "false",
                "data-boundary": "window",
              },
            },
            [
              _c("i", {
                staticClass: "fa fa-user mr-1 d-sm-none",
                attrs: { "aria-hidden": "true" },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "d-none d-sm-inline" }, [
                _vm._v(
                  _vm._s(
                    _vm.$translate("Ceres::Template.loginHello", {
                      username: _vm.username,
                    })
                  )
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "dropdown-menu small m-0 p-0 mw-100" }, [
            _c(
              "div",
              {
                staticClass: "list-group",
                attrs: { "aria-labelledby": "accountMenuList" },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "list-group-item small",
                    attrs: { href: _vm.$ceres.urls.myAccount },
                  },
                  [
                    _c("i", { staticClass: "fa fa-user" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "list-group-item small",
                    attrs: { href: "#" },
                  },
                  [
                    _c("i", { staticClass: "fa fa-sign-out" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.isLoggedIn & !_vm.showSingleLoginRegistration
      ? _c(
          "div",
          { staticClass: "h-100" },
          [
            _vm.showLogin && _vm.loginMode === "modal"
              ? _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    class: _vm.linkClass,
                    attrs: {
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                      "aria-label": _vm.$translate("Ceres::Template.login"),
                    },
                    on: {
                      click: function ($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      },
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-user mr-1",
                      class: _vm.logoClass,
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _vm.showLoginText
                      ? _c("span", { staticClass: "d-none d-sm-inline" }, [
                          _vm._v(
                            _vm._s(_vm.$translate("Ceres::Template.login"))
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showLogin && _vm.loginMode != "modal"
              ? _c(
                  "a",
                  {
                    staticClass: "nav-link ",
                    class: _vm.linkClass,
                    attrs: { href: _vm.routeLogin },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-user mr-1",
                      class: _vm.logoClass,
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(" "),
                    _vm.showLoginText
                      ? _c("span", { staticClass: "d-none d-sm-inline" }, [
                          _vm._v(
                            _vm._s(_vm.$translate("Ceres::Template.login"))
                          ),
                        ])
                      : _vm._e(),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showRegistration
              ? [
                  !_vm.showLogin
                    ? _c("span", { staticClass: "pipe" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.registrationMode === "modal"
                    ? _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          class: _vm.linkClass,
                          attrs: {
                            href: _vm.isRegister
                              ? "javascript:void(0)"
                              : "#registration",
                            "data-toggle": _vm.isRegister ? false : "modal",
                            "aria-label":
                              "$translate('Ceres::Template.loginRegister')",
                          },
                          on: {
                            click: function ($event) {
                              _vm.createRegisterModal()
                              _vm.unmarkInputFields()
                            },
                          },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-user-plus mr-1",
                            class: _vm.logoClass,
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _vm.showRegistrationText
                            ? _c(
                                "span",
                                { staticClass: "d-none d-sm-inline" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.loginRegister"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          class: _vm.linkClass,
                          attrs: { href: _vm.routeRegistration },
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-user-plus mr-1",
                            class: _vm.logoClass,
                            attrs: { "aria-hidden": "true" },
                          }),
                          _vm._v(" "),
                          _vm.showRegistrationText
                            ? _c(
                                "span",
                                { staticClass: "d-none d-sm-inline" },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$translate(
                                        "Ceres::Template.loginRegister"
                                      )
                                    )
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                ]
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }